import {useQuery} from "react-query";
import {
  QuicksightDashboard,
  QuicksightService,
} from "../../../services/QuicksightService";
import {
  dashboardsByEmailFromUsers,
  getQuicksightUsersDashboardsQueryKey,
} from "./quicksightUsersDashboards.helpers";

export {getQuicksightUsersDashboardsQueryKey} from "./quicksightUsersDashboards.helpers";

export type QuicksightUsersDashboardsData = Readonly<{
  dashboardOptions: ReadonlyArray<QuicksightDashboard>;
  dashboardsByEmail: Readonly<
    Record<string, ReadonlyArray<QuicksightDashboard>>
  >;
}>;

export const useQuicksightUsersDashboards = (
  emails: ReadonlyArray<string>,
) =>
  useQuery(
    getQuicksightUsersDashboardsQueryKey(emails),
    async (): Promise<QuicksightUsersDashboardsData> => {
      const {data} = await QuicksightService.getUsersDashboards(emails);

      return {
        dashboardOptions: data.dashboards,
        dashboardsByEmail: dashboardsByEmailFromUsers(emails, data.users),
      };
    },
    {enabled: emails.length > 0},
  );
